export interface IOptionType {
  options: string
}

const NORMALIZE_TYPE = {
  cogs: 'monday_lookback_status',
  laborTracker: 'labor_tracker_status',
  latestDataProcess: 'latest_data_process_status',
}

export interface IDataType {
  farwestNormalizeStatus?: string
}

const useNormalizeStatusType = ({ options }: IOptionType): IDataType => {
  return {
    farwestNormalizeStatus:
      NORMALIZE_TYPE[options as keyof typeof NORMALIZE_TYPE],
  }
}

export default useNormalizeStatusType
